/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';
export var addStyleByPredicate = function addStyleByPredicate(predicate) {
  return function (styles) {
    return function (props) {
      if (predicate(props)) {
        return function () {
          return styles;
        };
      }

      return function () {
        return '';
      };
    };
  };
};
export var addColors = function addColors(_ref) {
  var bgColor = _ref.bgColor,
      color = _ref.color,
      borderColor = _ref.borderColor,
      shadow = _ref.shadow;
  return css(["", " ", " ", " ", ""], bgColor && "background-color: ".concat(bgColor, ";"), color && "color: ".concat(color, ";"), borderColor && "border: 1px solid ".concat(borderColor, ";"), shadow && "box-shadow: ".concat(shadow, ";"));
};
export var getStyleValueByTypeof = function getStyleValueByTypeof(value) {
  if (typeof value === 'number') {
    return "".concat(value, "px");
  }

  return value;
};